const landing_page = {
  aboutUs: "私たちについて", // translated
  topPackages: "トップパッケージ", // translated
  featuredHotels: "注目のホテル", // translated
  topTours: "人気のツアー", // translated
  whatOurMembersSay: "メンバーの声は…", // translated
  followUsOnInstagram: "Instagramでフォローしてください", // translated
  pleaseWait: "お待ちください...", // translated
  packages: "パッケージ", // translated
  ourPartners: "当社のパートナー", // translated
  trustedCarHirePartners: "信頼できるレンタカーパートナー", // translated
  learnMore: "もっと詳しく知る", // translated
};



export default landing_page;
